import {BBModel} from "../../bb_model";
import {CompanyModel} from "./company";
import {convertMomentToTime} from "../../utils/convert_time";
import {event} from "../../services/event";
import {translations} from "../../constants/translations";
import { BaseModel } from "../base";

class EventModel extends BaseModel {

    constructor(data) {
        super(data);
        this.date = moment.parseZone(this.datetime);
        //this.time = new BBModel.TimeSlot({time: DateTimeUtilitiesService.convertMomentToTime(this.date)}); //TODO !!!
        this.time = new BBModel.TimeSlot({time: convertMomentToTime(this.date)});
        if (this.duration) {
            this.end_datetime = this.date.clone().add(this.duration, 'minutes');
        }
        this.date_unix = this.date.unix();
    }

    /**
     * @description
     * Get event groups
     *
     * @returns {promise} A promise for the group event
     */
    getGroup() {
        return new Promise((resolve, reject) => {
            if (this.group) {
                resolve(this.group);
            } else if (this.$has('event_groups') || this.$has('event_group')) {
                let event_group = 'event_group';
                if (this.$has('event_groups')) {
                    event_group = 'event_groups';
                }
                this.$get(event_group).then((group) => {
                        this.group = new BBModel.EventGroup(group);
                        return resolve(this.group);
                    }
                    , err => reject(err));
            } else {
                reject('No event group');
            }
        });
    }

    /**
     * @description
     * Get the chains of the event
     *
     * @returns {promise} A promise for the chains event
     */
    getChain(params) {
        return new Promise((resolve, reject) => {
            if (this.chain) {
                resolve(this.chain);
            } else {
                if (this.$has('event_chains') || this.$has('event_chain')) {
                    let event_chain = 'event_chain';
                    if (this.$has('event_chains')) {
                        event_chain = 'event_chains';
                    }
                    this.$get(event_chain, params).then((chain) => {
                            this.chain = new BBModel.EventChain(chain);
                            return resolve(this.chain);
                        }
                    );
                } else {
                    reject('No event chain');
                }
            }
        });
    }

    /**
     * @description
     * Get duration of the event chains
     *
     * @returns {promise} A promise for duration of the event
     */
    getDuration() {
        return new Promise((resolve, reject) => {
            if (this.duration) {
                resolve(this.duration);
            } else {
                this.getChain().then((chain) => {
                        this.duration = chain.duration;
                        return resolve(this.duration);
                    }
                );
            }
        });
    }


    /**
     * @description
     * Get duration of the event
     *
     * @returns {object} The returned description
     */
    getDescription() {
        return this.getChain().description;
    }

    /**
     * @description
     * Get the colour
     *
     * @returns {string} The returned colour
     */
    getColour() {
        if (this.getGroup()) {
            return this.getGroup().colour;
        } else {
            return '#FFFFFF';
        }
    }


    /**
     * @description
     * Get pounts
     *
     * @returns {integer} The returned pounts
     */
    getPounds() {
        if (this.chain) {
            return Math.floor(this.getPrice()).toFixed(0);
        }
    }

    /**
     * @description
     * Get price
     *
     * @returns {integer} The returned price
     */
    getPrice() {
        return 0;
    }

    /**
     * @description
     * Get price
     *
     * @returns {integer} The returned pence
     */
    getPence() {
        if (this.chain) {
            return (this.getPrice() % 1).toFixed(2).slice(-2);
        }
    }

    /**
     * @description
     * Get the number booked
     *
     * @returns {object} The returned number booked
     */
    getNumBooked() {
        return this.spaces_blocked + this.spaces_booked + this.spaces_reserved + this.spaces_held;
    }

    /**
     * @description
     * Get the number of spaces left (possibly limited by a specific ticket pool)
     *
     * @returns {object} The returned spaces left
     */
    getSpacesLeft(pool) {
        if (pool == null) {
            pool = null;
        }
        if (pool && this.ticket_spaces && this.ticket_spaces[pool]) {
            return this.ticket_spaces[pool].left;
        } else {
            const x = this.num_spaces - this.getNumBooked();
            if (x < 0) {
                return 0;
            }
            return x;
        }
    }


    /**
     * @description
     * Get the number of waitlist spaces left (possibly limited by a specific ticket pool)
     *
     * @returns {object} The returned spaces left
     */
    getWaitSpacesLeft() {
        let wait = this.chain.waitlength;
        if (!wait) {
            wait = 0;
        }
        wait = wait - this.spaces_wait;
        if (wait <= 0) {
            return 0;
        }

        return wait;
    }


    /**
     * @description
     * Checks if this considered a valid space
     *
     * @returns {boolean} If this is a valid space
     */
    hasSpace() {
        return (this.getSpacesLeft() > 0);
    }


    /**
     * @description
     * Checks if this considered a valid waiting list space
     *
     * @returns {boolean} If this is a valid waiting list space
     */
    hasWaitlistSpace() {
        return ((this.getSpacesLeft() <= 0) && (this.getChain().waitlength > this.spaces_wait));
    }

    /**
     * @description
     * Get the remaining description
     *
     * @returns {object} The returned remaining description
     */
    getRemainingDescription() {
        const left = this.getSpacesLeft();
        if ((left > 0) && (left < 3)) {
            //return $translate.instant('CORE.EVENT.SPACES_LEFT', {N: left}, 'messageformat'); //TODO !!!
            return translations.MODEL.EVENT.SPACES_LEFT;
        }
        if (this.hasWaitlistSpace()) {
            //return $translate.instant('CORE.EVENT.JOIN_WAITLIST');
            return translations.MODEL.EVENT.JOIN_WAIT_LIST;
        }
        return '';
    }

    /**
     * @description
     * Checks is this considered a selected
     *
     * @returns {boolean} If this is a selected
     */
    select() {
        return this.selected = true;
    }


    /**
     * @description
     * Unselect if is selected
     *
     * @returns {boolean} If this is a unselected
     */
    unselect() {
        if (this.selected) {
            return delete this.selected;
        }
    }

    /**
     * @description
     * Prepare the event
     *
     * @returns {promise} A promise for the event
     */
    prepEvent(params) {
        // build out some useful event stuff
        return new Promise((resolve, reject) => {
            this.getChain(params).then(() => {

                    if (this.chain.$has('address')) {
                        this.chain.$getAddress().then((address) => {
                                return this.chain.address = address;
                            }
                        );
                    }

                    return this.chain.getTickets().then((tickets) => {
                            this.tickets = tickets;

                            this.price_range = {};
                            if (tickets && (tickets.length > 0)) {
                                for (const ticket of Array.from(this.tickets)) {
                                    if (!this.price_range.from || (this.price_range.from && (ticket.price < this.price_range.from))) {
                                        this.price_range.from = ticket.price;
                                    }
                                    if (!this.price_range.to || (this.price_range.to && (ticket.price > this.price_range.to))) {
                                        this.price_range.to = ticket.price;
                                    }
                                    ticket.old_price = ticket.price;
                                }
                            } else {
                                this.price_range.from = this.price;
                                this.price_range.to = this.price;
                            }

                            this.ticket_prices = _.indexBy(tickets, 'name');

                            return resolve(this);
                        }
                    );
                }
            );
        });
    }

    /**
     * @description
     * Update price for the ticket
     *
     * @returns {object} The returned update price
     */
    updatePrice() {
        return Array.from(this.tickets)
            .map(ticket => (ticket.pre_paid_booking_id ? ticket.price = 0 : ticket.price = ticket.old_price));
    }

    static $query(model = null, params = null) {
        return model instanceof CompanyModel
            ? event.query(model, params)
            : event.queryByParams(model);
    }

    static $summary(company, params) {
        return event.summary(company, params);
    }

    /**
     * @returns {object} Gets number of selected tickets.
     */
    numTicketsSelected() {
        let number = 0;
        if (this.tickets) {
            for (const ticket of Array.from(this.tickets)) {
                number += ticket.qty;
            }
        }
        return number;
    }

    isComplexEvent() {
        return this.ticket_spaces !== undefined && this.ticket_spaces !== null;
    }
}

export {
    EventModel
};
